export const getPageLinks = ({
  totalPages = 0,
  currentPage = 0,
}: {
  totalPages: number
  currentPage: number
}) => {
  const pageLinks = []
  const maxLinks = 7 // Maximum number of page links to display
  const halfMaxLinks = Math.floor(maxLinks / 2)

  if (totalPages <= maxLinks) {
    return Array.from({ length: totalPages }, (_, i) => i + 1)
  }

  if (currentPage <= halfMaxLinks) {
    let i = 1
    while (i <= maxLinks - 1) {
      pageLinks.push(i)
      i += 1
    }
    pageLinks.push('...')
    pageLinks.push(totalPages)
    return pageLinks
  }

  if (currentPage > totalPages - halfMaxLinks) {
    pageLinks.push(1)
    pageLinks.push('...')

    let i = totalPages - (maxLinks - 2)
    while (i <= totalPages) {
      pageLinks.push(i)
      i += 1
    }
    return pageLinks
  }
  pageLinks.push(1)
  pageLinks.push('...')
  let i = currentPage - halfMaxLinks + 1
  while (i <= currentPage + halfMaxLinks - 1) {
    pageLinks.push(i)
    i += 1
  }
  pageLinks.push('...')
  pageLinks.push(totalPages)

  return pageLinks
}
